"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var utils_1 = require("../utils");
var createAbImpressionEvent = function (event) {
    var _a, _b;
    var abData = {
        event: analytics_layer_1.ABTestEventNames.ABImpression,
        eventInfo: analytics_layer_1.ABTestEventNames.ABImpression,
        ab: {
            "testName": ((_a = event.ab) === null || _a === void 0 ? void 0 : _a.testName) || consts_1.NOT_AVAILABLE,
            "experienceName": ((_b = event.ab) === null || _b === void 0 ? void 0 : _b.experienceName) || consts_1.NOT_AVAILABLE,
        }
    };
    return (0, utils_1.checkDataLayerValueEmpty)(abData);
};
exports.default = createAbImpressionEvent;
